var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 48,
    viewBox: "0 0 45 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mingcute:send-fill",
    clipPath: "url(#clip0_1253_100429)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M30.6391 17.829C31.0317 16.7431 29.9794 15.6908 28.8935 16.0843L15.6216 20.8841C14.5321 21.2785 14.4003 22.7652 15.4026 23.3459L19.6391 25.7985L23.4221 22.0155C23.5934 21.85 23.823 21.7584 24.0613 21.7604C24.2995 21.7625 24.5274 21.8581 24.6959 22.0266C24.8644 22.195 24.96 22.423 24.962 22.6612C24.9641 22.8995 24.8725 23.129 24.707 23.3004L20.924 27.0834L23.3775 31.3199C23.9573 32.3222 25.444 32.1895 25.8383 31.1009L30.6391 17.829Z",
    fill: "white",
    fillOpacity: 0.6
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1253_100429"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.2779,
    height: 48,
    fill: "white",
    transform: "translate(0.722168)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/Send.b0cad7216d6904b48e915d13fd601f84.svg";
export { ForwardRef as ReactComponent };